export const LABEL_FORMAT_SELECTOR_LABEL_FORMAT_NAME = "LABEL_FORMAT_SELECTOR_FORMAT_NAME";
export const LABEL_FORMAT_SELECTOR_LABEL_FORMAT_ID = "LABEL_FORMAT_SELECTOR_FORMAT_ID";
export const LABEL_FORMAT_SELECTOR_LABEL_FORMAT_BOTH = "LABEL_FORMAT_SELECTOR_FORMAT_BOTH";
